import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { paragraphSmall } from '@helpers/typography';
import svgTick from '@img/icons/tick.svg';
import styled from 'styled-components';
import { BackButtonStyles } from '../LocationMap.styles';
import { BackButtonIconStyles } from './../LocationMap.styles';
const Container = styled.section `
  display: flex;
  flex-direction: column;
  gap: ${fluid(18, 48)};
  padding: ${fluid(18, 32)};

  @media ${from(Device.TabletLarge)} {
    align-items: center;
    flex-direction: row;
  }
`;
const Form = styled.form `
  position: relative;
  flex: 1 1 auto;

  @media ${from(Device.TabletLarge)} {
    max-width: 456px;
  }

  @media ${from(Device.Desktop)} {
    flex: 1 1 50%;
  }
`;
const Input = styled.input `
  ${paragraphSmall};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background: ${brand.white};
  border: 0;
  color: ${brand.black};
  height: ${fluid(48, 54)};
  margin: 0;
  padding: 0 12px;
  padding-left: calc(12px + 25px + 16px);
  width: 100%;

  &::placeholder {
    ${fonts.brandonGrotesque.regular}
    opacity: 0.5;
  }
`;
const SubmitButton = styled.button `
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  background: none;
  border: 0;
  height: 25px;
  margin: 0;
  padding: 0;
  place-content: center;
  place-items: center;
  transform: translate(16px, -50%);
  width: 25px;
`;
const FilterWrapper = styled.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
`;
const FilterTitle = styled.span `
  display: block;
  ${fonts.brandonGrotesque.bold}
  font-size: 20px;
  line-height: 1em;
  margin: 0 0 1rem;
  text-transform: uppercase;

  @media ${from(Device.Desktop)} {
    margin: 0 0 18px;
  }
`;
const FilterList = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 12px ${fluid(16, 48)};
  margin: 0;

  @media ${from(Device.TabletLarge)} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;
const FilterItem = styled.li `
  display: flex;
  white-space: nowrap;

  input {
    ${srOnly}
  }

  label {
    display: inline-block;
    cursor: pointer;
    ${fonts.brandonGrotesque.regular}
    font-size: 20px;
    line-height: 1em;

    &::before {
      content: '';
      display: inline-block;
      height: 17px;
      background: ${brand.beige} no-repeat center center;
      background-size: 14px 14px;
      border: 1px solid ${brand.green};
      color: ${brand.white};
      margin: 0 8px -2px 0;
      width: 17px;
    }
  }

  input:checked + label::before {
    background-color: ${brand.green};
    background-image: url(${svgTick});
  }
`;
const BackWrapper = styled.div `
  flex: 0 0 auto;
  margin-left: auto;
`;
const BackButton = styled.button `
  ${BackButtonStyles}
`;
const BackIcon = styled.span `
  ${BackButtonIconStyles}
`;
const Divider = styled.hr `
  display: block;
  border: 0;
  border-bottom: 2px solid ${brand.green};
  margin: ${fluid(12, 30)} 0;
  padding: 0;
  width: 100%;
`;
const FilterSimpleStyles = {
    BackButton,
    BackIcon,
    BackWrapper,
    Container,
    FilterItem,
    FilterList,
    FilterTitle,
    FilterWrapper,
    Form,
    Input,
    SubmitButton,
    Divider,
};
export default FilterSimpleStyles;
